import * as React from 'react'
import { useReducer, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import GridContainer from '../grid/GridContainer'
import GridItem from '../grid/GridItem'
import CustomInput from '../input/CustomInput'
import Button from '../button/RegularButton'
import { timeout } from '../../App'
import Snackbar from '../snackbar/Snackbar'
import { AddAlert } from '@material-ui/icons'
import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import styles from '../../assets/jss/dorm-app/customSelectStyle.js'
import Checkbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import { initialNotificationState } from '../utils/state/ApplicationState'
import { getApiUrl } from '../../api/api'

const useStyles = makeStyles(styles)

function stateReducer(state, action) {
  switch (action.type) {
    case 'field':
      return {
        ...state,
        [action.field]: action.value,
      }
    case 'create':
      return {
        ...state,
      }

    case 'checkbox-compensate':
      return {
        ...state,
        compensate: !state.compensate,
      }

    case 'success':
      return {
        ...initialState,
        success: true,
      }

    case 'error':
      return {
        ...state,
        success: false,
      }

    default:
      break
  }
  return state
}

const initialState = {
  success: false,
  department: '',
  semester: '',
  tenantName: '',
  tenantSurname: '',
  tenantEmail: '',
  tenantRoom: '',
  points: '',
  compensate: false,
  note: '',
  engagementId: '',
}

export default function CreateEngagement() {
  const classes = useStyles()

  const [state, dispatch] = useReducer(stateReducer, initialState)

  const [notification, setNotification] = useState(initialNotificationState)

  const departments = {
    Heimrat: 'Heimrat',
    Finanzen: 'Finanzenreferat',
    Netzwerk: 'Netzwerkreferat',
    Tutoren: 'Tutoren',
    FS: 'Flursprecher',
    AA: 'Aufnahmereferat',
    AaNach: 'Aufnahmereferat-Nachrücker',
    Automat: 'Automatenreferat',
    Bar: 'Barreferat',
    BarFinanzen: 'Barreferat (Finanzen)',
    BarTechnik: 'Barreferat (Technik)',
    Billiard: 'Spielereferat',
    Computer: 'Computerreferat',
    Info: 'Inforeferat',
    Innen: 'Innenreferat',
    Kultur: 'Kulturreferat',
    Chor: 'Chor',
    Multimedia: 'Multimediareferat',
    Nachhaltigkeit: 'Nachhaltigkeitsreferat (Nachhaltigkeit)',
    NachhaltigkeitHochbeete: 'Nachhaltigkeitsreferat (Hochbeete)',
    Revisor: 'Revisoren',
    PR: 'PR-Referat',
    Schlichtung: 'Schlichtungsreferat',
    SportFussball: 'Sportreferat (Fußball)',
    SportVolleyball: 'Sportreferat (Volleyball)',
    SportFitness: 'Sportreferat (Fitness)',
    Tafel: 'Tafelreferat',
    WMarken: 'Waschmarkenverkäufer',
    WaMaFlur: 'Waschmarkenverkäufer Flur',
    WaMaTechnik: 'Waschmaschinenreferat (Technik)',
    WaMaLaufer: 'Waschmaschinenreferat (Läufer)',
    Werk: 'Werkreferat',
    Zimmer: 'Zimmerreferat',
    Zeitung: 'Zeitungreferat',
    Kreativreferat: 'Kreativreferat',
    HsvVertreter: 'HSV-Vertreter',
    Extra: 'Extra'
  }

  const semesters = {
    'WS23/24': 'Wintersemester 23/24',
    SS23: 'Sommersemester 23',
    'WS22/23': 'Wintersemester 22/23',
    SS22: 'Sommersemester 22',
    'WS21/22': 'Wintersemester 21/22',
    SS21: 'Sommersemester 21',
    'WS20/21': 'Wintersemester 20/21',
    SS20: 'Sommersemester 20',
    'WS19/20': 'Wintersemester 19/20',
    SS19: 'Sommersemester 19',
    'WS18/19': 'Wintersemester 18/19',
    SS18: 'Sommersemester 18',
  }

  const submitForm = (e) => {
    e.preventDefault()

    dispatch({ type: 'create' })


    getApiUrl()
      .post(`/api/engagements`, state)
      .then(function() {
        dispatch({ type: 'success' })
        setNotification({
          open: true,
          message: 'Amt hinzugefügt',
          color: 'success',
        })
      })
      .catch(function(error) {
        dispatch({ type: 'error' })
        setNotification({
          open: true,
          message: error.response.data.message,
          color: 'danger',
        })
      })
      .finally(
        setTimeout(function() {
          setNotification(initialNotificationState)
        }, timeout),
      )
  }

  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={3}>
            <FormControl fullWidth className={classes.selectFormControl}>
              <InputLabel htmlFor="department" className={classes.selectLabel}>
                Referat
              </InputLabel>
              <Select
                MenuProps={{
                  className: classes.selectMenu,
                }}
                classes={{
                  select: classes.select,
                }}
                value={state.department}
                onChange={(e) => {
                  dispatch({
                    type: 'field',
                    field: 'department',
                    value: e.currentTarget.getAttribute('data-value'),
                  })
                }}
                inputProps={{
                  name: 'department',
                  id: 'department',
                }}>
                {departments
                  ? Object.entries(departments).map(([key, value]) => (
                    <MenuItem
                      key={key}
                      classes={{
                        root: classes.selectMenuItem,
                        selected: classes.selectMenuItemSelected,
                      }}
                      value={key}>
                      {value}
                    </MenuItem>
                  ))
                  : []}
              </Select>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={3}>
            <FormControl fullWidth className={classes.selectFormControl}>
              <InputLabel htmlFor="semester" className={classes.selectLabel}>
                Semester
              </InputLabel>
              <Select
                MenuProps={{
                  className: classes.selectMenu,
                }}
                classes={{
                  select: classes.select,
                }}
                value={state.semester}
                onChange={(e) => {
                  dispatch({
                    type: 'field',
                    field: 'semester',
                    value: e.currentTarget.getAttribute('data-value'),
                  })
                }}
                inputProps={{
                  name: 'semester',
                  id: 'semester',
                }}>
                {semesters
                  ? Object.entries(semesters).map(([key, value]) => (
                    <MenuItem
                      classes={{
                        root: classes.selectMenuItem,
                        selected: classes.selectMenuItemSelected,
                      }}
                      value={key}>
                      {value}
                    </MenuItem>
                  ))
                  : []}
              </Select>
            </FormControl>
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem xs={12} sm={12} md={3}>
            <CustomInput
              labelText="Email"
              id="tenantEmail"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{
                value: state.tenantEmail,
                type: 'text',
                onChange: (e) =>
                  dispatch({
                    type: 'field',
                    field: 'tenantEmail',
                    value: e.currentTarget.value,
                  }),
              }}
            />
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem xs={12} sm={12} md={3}>
            <CustomInput
              labelText="Vorname"
              id="tenantName"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{
                value: state.tenantName,
                type: 'text',
                onChange: (e) =>
                  dispatch({
                    type: 'field',
                    field: 'tenantName',
                    value: e.currentTarget.value,
                  }),
              }}
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={3}>
            <CustomInput
              labelText="Nachname"
              id="tenantSurname"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{
                value: state.tenantSurname,
                type: 'text',
                onChange: (e) =>
                  dispatch({
                    type: 'field',
                    field: 'tenantSurname',
                    value: e.currentTarget.value,
                  }),
              }}
            />
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem xs={12} sm={12} md={3}>
            <h5>Entweder Name oder Email kann angegeben werden.</h5>
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem xs={12} sm={12} md={2}>
            <FormControlLabel
              value="compensate"
              control={
                <Checkbox
                  checked={state.compensate}
                  onChange={() =>
                    dispatch({
                      type: 'checkbox-compensate',
                    })
                  }
                />
              }
              style={{ marginTop: '43px' }}
              label="Sofort entlasten"
              labelPlacement="end"
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <CustomInput
              labelText="Notiz (optional)"
              id="note"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{
                value: state.note,
                type: 'text',
                onChange: (e) =>
                  dispatch({
                    type: 'field',
                    field: 'note',
                    value: e.currentTarget.value,
                  }),
              }}
            />
          </GridItem>
        </GridContainer>
        <br/>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <Button
              color="primary"
              onClick={(e) => {
                submitForm(e)
              }}>
              Amt hinzufügen
            </Button>
          </GridItem>
        </GridContainer>
        <Snackbar
          place="br"
          color={notification.color}
          icon={AddAlert}
          message={notification.message}
          open={notification.open}
          closeNotification={() =>
            setNotification({
              open: false,
              message: '',
              color: '',
            })
          }
          close
        />
      </GridItem>
    </GridContainer>
  )
}
